import { FunctionComponent } from "react";
import TextFieldAtom, {
  TextFieldAtomType,
} from "../../../../../src/atoms/textfield";

export const TextField: FunctionComponent<TextFieldAtomType> = (props) => {
  return <TextFieldAtom {...props} />;
};

TextField.displayName = "TextField";

export default TextField;
